const state = {
  isLoaded: false
}

const getters = {}

const mutations = {
  SET_DATA: (state, data) => state[data.name] = data.item,
  SET_IS_LOADED: state => state.isLoaded = true
}
const actions = {
  GET_DATA: context => fetch('/data/data.json')
    .then(response => response.json())
    .then(data => {
      const entries = Object.entries(data)

      for (let [name, item] of entries) {
        context.commit('SET_DATA', { name, item })
      }
    })
    .then(() => context.commit('SET_IS_LOADED'))
}

export default {
  state,
  getters,
  mutations,
  actions
}
